import { useMemo } from "react";
import { ROUTE } from "@/lib/utils";
import { collectionToRoute } from "../utils";

export function useInboxHref(dataMap) {
  return useMemo(() => {
    const hrefHandlers = {
      projects: (item) => {
        const projectData = dataMap[`projects-${item}`];
        return projectData?.project_id
          ? `${collectionToRoute.projects}/${projectData.project_id}`
          : collectionToRoute.projects;
      },
      jobs: (item) => {
        const jobData = dataMap[`jobs-${item}`];
        return jobData?.id ? ROUTE.JOB(jobData.id) : ROUTE.JOBS();
      },
      job_extensions: (item) => {
        const jobExtensionData = dataMap[`job_extensions-${item}`];
        return jobExtensionData?.job?.id
          ? `/work/jobs/${jobExtensionData.job.id}/extensions/${jobExtensionData.id}`
          : ROUTE.JOBS();
      },
      milestones: (item) => {
        const milestoneData = dataMap[`milestones-${item}`];
        return milestoneData?.id
          ? ROUTE.MILESTONE(milestoneData.id)
          : ROUTE.MILESTONES();
      },
      tickets: (item) => {
        const ticketData = dataMap[`tickets-${item}`];
        return ticketData?.id
          ? `${collectionToRoute.tickets}/${ticketData.id}`
          : collectionToRoute.tickets;
      },
      billables: (item) => {
        const billableData = dataMap[`billables-${item}`];
        return billableData?.id
          ? ROUTE.BILLABLE_ACTIVITY(billableData.id)
          : collectionToRoute.billables;
      },
    };

    return (notification) => {
      const { collection, item } = notification;
      const handler = hrefHandlers[collection];

      return handler ? handler(item) : collectionToRoute[collection];
    };
  }, [dataMap]);
}
